<template>
	<div style="padding: 5px 10px;">
		<div class="input-group col-xs-12">
			<select title="计算方法" class="form-control" list="method_list" name="method" v-model="methodId" @change="$emit('changemethod',$event)">
					<option value="-1">未选择</option>
					<option v-for="(method,index) in items" :value="index">{{method.name}}({{method.lable}})</option>
				</select>
			<span class="input-group-btn">  
					<button v-if="methodId==-1" disabled class="btn btn-default" type="submit" @click="$emit('calcu')">开始</button>  
					<button v-else class="btn btn-default" type="submit" @click="$emit('calcu')">开始</button>  
				</span>
		</div>
		<p v-show="getCurrentMethod().desc" class="text-info text-center" style="margin:0;padding: 20px 0;">{{getCurrentMethod().desc}}</p>
	</div>
</template>

<script>
	export default {
		props: ['items'],
		data: function () {
			return {
				methodId: -1,
			}
		},
		methods: {
			getCurrentMethod: function () {
				if (this.methodId != -1) {
					return this.items[this.methodId]
				} else {
					return {}
				}
			},
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// calcumethods-select.vue?771601bc